import { TiDelete } from "react-icons/ti";

import * as types from "types";
import { useUploadFile } from "contexts/UploadContext";
import { useIsThreadStreaming } from "services/cortevaChain/hooks/activeStreams";
import styles from "./Message.module.scss";

interface DeleteFileButtonProps {
  chatThread: types.ChatThread;
  fileId?: string | null;
  messageUuid: string;
}
export default function DeleteFileButton({
  chatThread,
  fileId,
  messageUuid,
}: DeleteFileButtonProps) {
  const { handleDelete } = useUploadFile({
    threadId: chatThread.id,
  });
  // A delete would have to wait for the reply to end (ADR 071).
  const isStreaming = useIsThreadStreaming(chatThread.id);
  return (
    <button
      className={`${styles.deleteFile} bg-transparent bn pa0 dim pointer gray`}
      disabled={isStreaming}
      onClick={() => handleDelete(messageUuid, fileId)}
    >
      <TiDelete size={20} />
    </button>
  );
}
